import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useCallback, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'
import { LOCATIONS_SEPARATOR } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../../../../translations'
import { TRANSLATION_KEYS as APPLICABLE_TRANSLATION_KEYS } from '../../../../applicableToggle/translations'
import { LocationsListDialog } from '../../../../locationsListDialog/LocationsListDialog'

import styles from './BranchesReadMode.module.scss'

interface IBranchReadModeProps {
  isApplicable: boolean
  count: Nullable<number>
  locations: string
  isCountEnabled?: boolean
  isLocationsEnabled?: boolean
}

export const BranchesReadMode: FC<IBranchReadModeProps> = ({
  isApplicable,
  count,
  locations: locationsString,
  isCountEnabled = true,
  isLocationsEnabled = true,
}) => {
  const [showLocationsList, setShowLocationsList] = useState(false)

  const locations = useMemo(() => {
    return locationsString.split(LOCATIONS_SEPARATOR).filter((it) => it)
  }, [locationsString])

  const formattedCount = useMemo(() => {
    if (count === null) {
      return '-'
    }

    return getFormattedFinance(count, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [count])

  const closeLocationsList = useCallback(() => {
    setShowLocationsList(false)
  }, [])

  const openLocationsList = useCallback(() => {
    setShowLocationsList(true)
  }, [])

  if (!isApplicable) {
    return (
      <div className={styles.root}>
        <b>
          <Translation text={APPLICABLE_TRANSLATION_KEYS.notApplicable} />
        </b>
      </div>
    )
  }

  return (
    <div className={styles.root}>
      {isCountEnabled && (
        <>
          <div className={styles.countWrapper}>
            <div className={styles.countValue}>{formattedCount}</div>
            <div className={styles.countLabel}>
              <Translation text={TRANSLATION_KEYS.locationsAndCount.countLabel} />
            </div>
          </div>
        </>
      )}
      {isLocationsEnabled && (
        <>
          <div className={styles.locationWrapper} onClick={openLocationsList}>
            <div className={styles.iconContainer}>
              <i className="kbase kbase-omni-location-pin" />
            </div>
            <div className={styles.locationContent}>
              <div className={styles.locationValue}>{locations[0] || '-'}</div>
              <div className={styles.locationLabel}>
                <Translation text={TRANSLATION_KEYS.locationsAndCount.locationsClickToViewLabel} />
              </div>
            </div>
          </div>
          {showLocationsList && (
            <LocationsListDialog onClose={closeLocationsList} locations={locationsString} />
          )}
        </>
      )}
    </div>
  )
}
